import { isPlatformBrowser } from '@angular/common';
var DeviceService = /** @class */ (function () {
    function DeviceService(platformId, req) {
        this.req = req;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    Object.defineProperty(DeviceService.prototype, "device", {
        get: function () {
            var userAgent;
            //TODO: Refactor when we have testing for this.
            if (!this.isBrowser) {
                //We are SSR. If we are bethind cloudfront we can have several headers
                var mobile = this.req.headers['cloudfront-is-mobile-viewer'];
                if (mobile) {
                    return 'mobile';
                }
                var desktop = this.req.headers['cloudfront-is-desktop-viewer'];
                if (desktop) {
                    return 'desktop';
                }
                var tablet = this.req.headers['cloudfront-is-tablet-viewer'];
                if (desktop) {
                    return 'tablet';
                }
            }
            if (this.isBrowser) {
                userAgent = navigator.userAgent;
            }
            else {
                userAgent = this.req.headers["user-agent"];
            }
            if (userAgent.match(/Tablet|iPad/i)) {
                return 'tablet';
            }
            else if (userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i)) {
                return 'mobile';
            }
            else {
                return 'desktop';
            }
        },
        enumerable: true,
        configurable: true
    });
    DeviceService.prototype.constructCloudfrontURL = function (url, size) {
        if (size === void 0) { size = "LARGE"; }
        return "" + url + DeviceService.SIZE_MATRIX[this.device][size];
    };
    /**
     * detect IE
     * returns version of IE or -1, if browser is not Internet Explorer
     */
    DeviceService.prototype.detectIE = function () {
        var ua = window.navigator.userAgent;
        // Test values; Uncomment to check result …
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // IE 12 / Spartan
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // Edge (IE 12+)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        // other browser
        return -1;
    };
    DeviceService.SIZE_MATRIX = {
        'mobile': {
            'MICRO': 'micro',
            'SMALL': 'small',
            'MEDIUM': 'medium',
            'LARGE': 'medium'
        },
        'tablet': {
            'MICRO': 'micro',
            'SMALL': 'small',
            'MEDIUM': 'medium',
            'LARGE': 'medium'
        },
        'desktop': {
            'MICRO': 'micro',
            'SMALL': 'small',
            'MEDIUM': 'medium',
            'LARGE': 'large'
        }
    };
    return DeviceService;
}());
export { DeviceService };
